export default {
  methods: {
    mixin_GetCompanyName(c) {
      if (c == "YE") return "源穎";
      else if (c == "RVITA") return "維他露";
      else if (c == "RVITA,YE") return "維他露/源穎";
      else return null;
    },
    mixin_GetCompanyID(c) {
      if (c == "源穎") return "YE";
      else if (c == "維他露") return "RVITA";
      else if (c == "維他露/源穎") return "RVITA,YE";
      else return null;
    },
  },
};
